import React, { Component } from 'react';
import Text from 'react-format-text';
import { MapPin } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';

import { Gallery as ReactGallery } from '../../ReactGridGallery';
import { CustomContainer } from '../../common';
import { UserLink } from '../../Links';
import {
  checkImageURL,
  formatTimestamp,
  getPushIcon,
  getUrls,
  parseImgurURL,
} from '../../Utils';

interface PushProps {
  content: string;
  authorId: string;
  datetime: string;
  floor?: number;
  shouldShowFloors: boolean;
  tag: string;
  isMobile: boolean;
  city?: string;
  code2?: string;
  country?: string;
}

interface PushState {
  urls: string[];
}

class Push extends Component<PushProps, PushState> {
  state: PushState = {
    urls: [],
  };

  componentDidMount() {
    const { content } = this.props;

    const urls = getUrls(content);
    const validURLS = urls
      .map(url => parseImgurURL(url))
      .filter(url => checkImageURL(url));

    this.setState({
      urls: validURLS,
    });
  }

  render() {
    const {
      city,
      code2,
      content,
      country,
      floor,
      tag,
      datetime,
      authorId,
      isMobile,
    } = this.props;

    const { urls } = this.state;

    return (
      authorId &&
      content && (
        <div className="py-3 border-b last:border-b-0">
          <div className="flex-1">
            <div className="flex items-start justify-between mb-1">
              <div className="flex items-center gap-2">
                {floor && (
                  <span className="text-teal-600 font-bold">{floor}樓</span>
                )}
                {getPushIcon(tag, isMobile ? 'sm' : 'md')}
                <UserLink id={authorId}>
                  <span className="font-semibold hover:underline">
                    {authorId}
                  </span>
                </UserLink>
              </div>
              <span className="text-sm text-gray-500 flex-shrink-0">
                {formatTimestamp(datetime, isMobile)}
              </span>
            </div>
            <div className={isMobile ? 'text-sm' : 'text-base'}>
              <Text>
                {isMobile && content.length > 80
                  ? content.substring(0, 80).trim() + '...'
                  : content}
              </Text>
              {urls.length > 0 && (
                <div className="mt-2">
                  <ReactGallery
                    enableImageSelection={false}
                    images={urls.map(url => ({
                      src: url,
                      width: 1,
                      height: 1,
                    }))}
                  />
                </div>
              )}
            </div>
            {code2 && (
              <div className="flex justify-end mt-2">
                <span className="text-xs text-gray-500 flex items-center gap-1">
                  <MapPin className="h-3 w-3" />
                  {city} ({country}{' '}
                  <span className={`fi fi-${code2.toLowerCase()}`}></span>)
                </span>
              </div>
            )}
          </div>
        </div>
      )
    );
  }
}

export default ({
  data,
  total,
  isMobile,
}: {
  data: any[];
  total: number;
  isMobile: boolean;
}) => {
  if (!Array.isArray(data) || data.length === 0) {
    return null;
  }

  const shouldShowFloors =
    data.filter(push => push.floor !== null).length === data.length;

  return (
    <CustomContainer>
      <Card>
        <CardHeader>
          <CardTitle className={isMobile ? 'text-xl' : 'text-2xl'}>
            推 / 噓 / 回文 ({total})
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-0">
            {data.map(push => (
              <Push
                key={push.id}
                city={push.city}
                code2={push.code2}
                content={push.content}
                country={push.country}
                floor={shouldShowFloors ? push.floor : null}
                tag={push.tag}
                datetime={push.timestp}
                authorId={push.user_id}
                isMobile={isMobile}
                shouldShowFloors={shouldShowFloors}
              />
            ))}
          </div>
        </CardContent>
      </Card>
    </CustomContainer>
  );
};

